import { find, compact } from 'lodash';
import PAGES from 'constants/pages';
import api from 'config/api';
import appConfigMock from './app.config-mock.json';
import requester from 'utils/requester';
import { menuItemType } from './types';

const isScreeen = (item) => item.app_url.includes('screen://');

const PROFILE = { id: PAGES.PROFILE, path: '/profile', title: 'Profile' };

// const SEARCH = { id: PAGES.SEARCH, path: '/search', title: 'Search' };

const HOME = {
  id: PAGES.HOME,
  path: '/',
  title: 'Home',
  type: 'home',
};

const LIVE_TV = {
  id: PAGES.LIVE_TV,
  path: '/live-tv',
  title: 'TV',
};

const VOD = {
  id: PAGES.VOD,
  path: '/vod',
  title: 'Video',
};

const MY_WATCHLIST = {
  id: PAGES.MY_WATCHLIST,
  path: '/my-watchlist',
  title: 'My List',
};

const menuMapper = {
  'ui://mylist': MY_WATCHLIST,
  'ui://tv': LIVE_TV,
  'ui://vod': VOD,
};

export const mapMenuItems = (items, screens) => {
  const DEFAULT_MENU_ITEMS = [
    // SEARCH
    PROFILE,
  ];

  return [...DEFAULT_MENU_ITEMS].concat(
    items.map((item) => {
      if (item.type === 'home' && !isScreeen(item)) return HOME;

      if (menuMapper[item.app_url]) return menuMapper[item.app_url];

      if (isScreeen(item)) {
        const extId = item.app_url.replace('screen://', '');
        const screen = find(screens, { ext_id: extId });

        const id = PAGES.SCREEN;
        const title = screen?.name || item.title;
        const path = `/screen/${extId}`;
        const type = item.type;

        return { id, title, path, type };
      }

      return item;
    }),
  );
};

export const loadMenuItems = async () => {
  const CLIENT_ID = 'mometu';

  let menuItems: menuItemType[] = [];

  try {
    const config = await requester({
      method: 'get',
      url: `https://${CLIENT_ID}.sotalcloud.com/config.json`,
    });
    menuItems = config.menu;
  } catch (error) {
    menuItems = appConfigMock.menu;
  }

  let screens = [];

  try {
    const repospone = await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.screens}`,
    });
    screens = repospone.data;
  } catch (error) {
    console.error(error);
  }

  const items = compact(mapMenuItems(menuItems, screens));

  return items;
};
